module.exports = __webpack_public_path__ + "static/media/jinray-artfair.236434aa.jpg";